import { useQuery } from '@apollo/client'
import { graphql } from '../../../../gql'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDown, UserCircle } from 'lucide-react'
import * as styled from '../../../../util/styled'
import { useLegacyModal } from '../../../../hooks/useLegacyModal'
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag'

const UserInfoContainer = styled.div('bg-brand text-white flex flex-col p-5 border-bottom border-border-standby')
const UserInfoContainerTitle = styled.div('text-xs text-white/80')
const UserName = styled.div('font-semibold text-3xl text-white')
const Email = styled.div('text-sm text-white')

const ButtonItem = styled.button('w-full text-start px-5 py-3 block data-[focus]:bg-surface-darker hover:bg-surface-darker')
const LinkItem = styled.anchor('w-full text-start px-5 py-3 block data-[focus]:bg-surface-darker hover:bg-surface-darker')


const LoadLoggedInUserForHeader = graphql(`
  query LoadLoggedInUserForHeader {
    me {
      id
      firstName
      lastName
      email
      rawStr
    }
  }
`)

export const LoggedInUserMenu = () => {
  const { data } = useQuery(LoadLoggedInUserForHeader)
  const subscriptionModal = useLegacyModal('subscription')
  const updateAccountModal = useLegacyModal('update_account')
  const updatePaymentModal = useLegacyModal('update_payment')
  const updateHubspot = useLegacyModal('integration')
  const [, setV2Enabled] = useFeatureFlag('v2')

  return (
    <Menu>
      <MenuButton className={styled.cx('flex items-center justify-center gap-2')}>
        <UserCircle className="w-5 h-5" />
        <ChevronDown className="w-5 h-5" />
      </MenuButton>
      <MenuItems anchor="bottom end" className="bg-surface-elevated rounded-lg shadow-lg mt-2 w-[300px]">
        <MenuItem>
          <UserInfoContainer>
            <UserInfoContainerTitle>Logged in as</UserInfoContainerTitle>
            <UserName>{data?.me?.firstName} {data?.me?.lastName}</UserName>
            <Email>{data?.me?.email}</Email>
          </UserInfoContainer>
        </MenuItem>
        <MenuItem>
          <ButtonItem onClick={() => subscriptionModal.setOpen(true)}>
            Update Subscription
          </ButtonItem>
        </MenuItem>
        <MenuItem>
          <ButtonItem onClick={() => updateAccountModal.setOpen(true)}>
            Update Account
          </ButtonItem>
        </MenuItem>
        <MenuItem>
          <ButtonItem onClick={() => updatePaymentModal.setOpen(true)}>
            Update Payment Details
          </ButtonItem>
        </MenuItem>
        <MenuItem>
          <ButtonItem onClick={() => updateHubspot.setOpen(true)}>
            Configure Hubspot
          </ButtonItem>
        </MenuItem>
        <MenuItem>
          <ButtonItem onClick={() => {
            setV2Enabled(false)
            window.location.reload()
          }}>
            Disable Refreshed JRO
          </ButtonItem>
        </MenuItem>
        <MenuItem>
          <LinkItem href="/users/sign_out" className='pb-4'>
            Logout
          </LinkItem>
        </MenuItem>

      </MenuItems>
    </Menu>
  )
}
